import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import BaseSearch from './BaseSearch'
import {
  fetchResultSearch,
  clearSearch,
  setFilterChanged,
  resetState,
  SearchFiltered
} from '../ducks'

import { Sidebar, NotFound, SearchTitle } from '..'
import InfiniteScroll from 'react-infinite-scroller'
import { Button } from 'loyal-react'
import { setMetadata } from 'Shared/HeadMetadata/ducks'
import MediaQuery from 'react-responsive'

import '@loyal_template/search.css'
import { ServiceCardContainer } from 'Catalog/Service/ServiceCard'
import { ProductCardContainer } from 'Catalog/Product/ProductCard'

import Tagging from 'Catalog/Product/ProductCard/Tagging'
import titleName from './Title'
import Helmet from 'react-helmet'

import AriaModal from 'react-aria-modal'

// Main component logic based on search
const MainComponent = ({
  services,
  titleShowcase,
  categoryName,
  products,
  isSearch,
  hasMoreItems,
  loadItems,
  activeTagging,
  activePagination,
  notFound
}) => {
  if (notFound) {
    return <NotFound isSearch={isSearch} />
  } else {
    return (
      <InfiniteScroll
        initialLoad={false}
        pageStart={0}
        loadMore={() => {
          activeTagging()
          activePagination()
          loadItems()
        }}
        hasMore={hasMoreItems}
        loader={<Button loading text='Carregando' className='btn-flat' />}
      >
        <div className='row'>
          {services.map(service => (
            <Fragment>
              <MediaQuery minDeviceWidth={426}>
                <ServiceCardContainer
                  className='col-6 col-lg-4 mb-2 px-1 d-md-flex'
                  path={service.path}
                  key={service.name}
                  name={service.name}
                />
              </MediaQuery>
              <MediaQuery maxDeviceWidth={425}>
                <ServiceCardContainer
                  isResponsiveEnabled
                  className='col-12 mb-1 px-half d-block card-mobile'
                  path={service.path}
                  key={service.name + '_mobile'}
                  name={service.name}
                />
              </MediaQuery>
            </Fragment>
          ))}

          {products.map((product, index) => (
            <Fragment>
              <MediaQuery minDeviceWidth={426}>
                <ProductCardContainer
                  className='col-6 col-lg-4 mb-2 px-1 d-md-block'
                  sku={product.sku}
                  key={product.sku}
                  identifier='search-page'
                  titleShowcase={titleShowcase}
                  categoryName={categoryName}
                  position={index}
                />
              </MediaQuery>
              <MediaQuery maxDeviceWidth={425}>
                <ProductCardContainer
                  isResponsiveEnabled
                  className='col-12 mb-1 px-half d-block card-mobile'
                  sku={product.sku}
                  key={product.sku + '_mobile'}
                  identifier='search-page'
                  titleShowcase={titleShowcase}
                  categoryName={categoryName}
                  position={index}
                />
              </MediaQuery>
            </Fragment>
          ))}
        </div>
      </InfiniteScroll>
    )
  }
}

MainComponent.propTypes = {
  products: PropTypes.object,
  titleShowcase: PropTypes.string,
  categoryName: PropTypes.string,
  hasMoreItems: PropTypes.func,
  isSearch: PropTypes.bool,
  loadItems: PropTypes.func,
  activeTagging: PropTypes.func,
  activePagination: PropTypes.func,
  notFound: PropTypes.bool,
  taggingSend: PropTypes.bool,
  sendGTM: PropTypes.bool,
  updateSendGTM: PropTypes.func
}

class SearchPage extends BaseSearch {
  constructor (props) {
    super(props)

    this.state = {
      taggingSend: true,
      sendGTM: false,
      qtdProducts: 0,
      paginationSearch: true
    }

    this.activeTagging = this.activeTagging.bind(this)
    this.updateSendGTM = this.updateSendGTM.bind(this)
    this.activePagination = this.activePagination.bind(this)
  }

  updateSendGTM () {
    this.setState({
      sendGTM: true,
      taggingSend: true
    })
  }

  activeTagging () {
    setTimeout(() => {
      this.setState({
        taggingSend: false,
        paginationSearch: false
      })
    }, 1000)
  }

  activePagination () {
    this.setState({
      paginationSearch: false
    })
  }
  componentWillMount () {
    this.props.resetState()
    if (this.props.filterSelected) {
      this.props.filterSelected.maxprice = 0
      this.props.filterSelected.minprice = 0
    }
  }
  shouldComponentUpdate (nextProps, nextState) {
    const propsChanged =
      JSON.stringify(nextProps) !== JSON.stringify(this.props)
    const stateChanged =
      JSON.stringify(nextState) !== JSON.stringify(this.state)

    return propsChanged || stateChanged
  }

  getApplicationNode = () => {
    return document.querySelector('#root')
  }

  removeTabIndex () {
    setTimeout(() => {
      const contentModalFilter = document.querySelector('#filter-opened')
      contentModalFilter && contentModalFilter.removeAttribute('tabindex')
    }, 300)
  }

  handleApplyFilterModal () {
    this.handleFilter()

    setTimeout(() => {
      document.querySelector('.btn-back-page').focus()
    }, 300)
  }

  render () {
    const {
      services,
      products,
      categories,
      subcategories,
      filterSelected,
      isLoading,
      hasNoProducts,
      hasMoreItems
    } = this.props

    const { term, category, subcategory, vendor } = filterSelected
    const isSearch = !!term
    const notFound = !isLoading && hasNoProducts
    const ariaLabel = 'Resultado da busca'
    let title = ''
    let categoryName = ''

    // Title based on search type
    if (!term) {
      if (categories && categories.length && category.length) {
        title = categories[0].name
      } else if (subcategories && subcategories.length && subcategory.length) {
        title = subcategories[0].name
      } else if (this.props.vendors && this.props.vendors.length > 0 && vendor.length === 1) {
        title = titleName(this.props.vendors, vendor[0])
      }
    } else {
      title = term
    }

    if (subcategories && subcategories.length && subcategory.length) {
      categoryName = subcategories[0].name
    } else if (categories && categories.length && category.length) {
      categoryName = categories[0].name
    }

    if (this.state.qtdProducts !== products.length && !this.state.paginationSearch) {
      this.setState({
        qtdProducts: products.length,
        paginationSearch: true
      })
    }

    this.activeTagging()

    return (
      <Fragment>
        <Helmet>
          <title>{`Resultado de busca - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>

        <div className='searchpage-file container-fluid' data-cat={categoryName}>
          {
            (!this.state.sendGTM && !this.state.taggingSend) || (this.state.paginationSearch && !this.state.taggingSend) ? (
              <Fragment>
                { this.updateSendGTM() }
                <Tagging type='send' />
              </Fragment>
            ) : ''
          }
          <input
            type='text'
            style={{ width: '1px', height: '1px' }}
            aria-label={ariaLabel}
            readOnly
            aria-hidden
            tabIndex={-1}
          />
          <div className='container mt-0'>
            <div className='row'>
              <SearchTitle
                title={title}
                isSearch={isSearch}
                isLoading={isLoading}
                quantityFoundProducts={this.props.quantityFoundProducts}
                className={`${
                  !this.state.condition ? 'd-flex d-md-flex' : 'd-none d-md-flex'
                }`}
              />

              <div
                className={`col-12 px-0 pt-0 pb-2 ${
                  !this.state.condition ? 'd-block d-md-none' : 'd-none d-md-none'
                }`}
              >
                <Button
                  id={'button-filtrar-mobile'}
                  name={'BUTTON'}
                  text='Filtrar'
                  iconName='icon_filter'
                  className='col-12 btn-sm '
                  onClick={this.handleFilter}
                />
              </div>

              {this.state.condition && <AriaModal
                titleText='Filtros para busca'
                onExit={() => {
                  this.handleFilter()
                }}
                getApplicationNode={this.getApplicationNode}
                underlayStyle={{ paddingTop: '0px', zIndex: 99999, backgroundColor: '#FFF' }}
                initialFocus='#filter-opened'
                focusDialog
              >
                <div data-campaign={process.env.REACT_APP_CATALOG_ID}>
                  <div
                    id='filter-opened'
                    className='h-100 w-100 px-2 py-2'
                    onBlur={this.removeTabIndex}
                    tabIndex={0}>
                    <div
                      className={`col-12 px-0 pt-0 pt-md-2 pb-2 d-block d-md-none`}
                    >
                      <div className='row'>
                        <div className='col-12 px-0'>
                          <Button
                            id={'button-voltar-mobile'}
                            name={'BUTTON'}
                            text='Voltar'
                            iconName='icon_left icon-sm'
                            className='btn-sm'
                            onClick={() => {
                              this.handleFilter()
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <Sidebar
                      subcategories={subcategories}
                      brands={this.props.brands}
                      vendors={this.props.vendors}
                      features={this.props.features}
                      handleFilterChanged={this.handleFilterChanged}
                      handleSelectOrdinationFilterChanged={this.handleSelectOrdinationFilterChanged}
                      handleFilterRemove={this.handleFilterRemove}
                      handleFilterClean={this.handleFilterClean}
                      filterSelected={filterSelected}
                      priceLimit={this.props.priceLimit}
                      pageType='search'
                      isLoading={isLoading}
                      ordination={this.state.ordination}
                      className={`${'d-block d-md-block'}`}
                      onlyCash={this.props.onlyCash}
                    />
                    <div className='bg-white px-2 py-2 row mx-0 '>
                      <div className='col-12 px-0'>
                        <button
                          className='btn btn-sm btn-featured'
                          onClick={() => { this.handleApplyFilterModal() }}
                        >Aplicar</button>
                      </div>
                    </div>
                  </div>
                </div>
              </AriaModal> }
              <Sidebar
                subcategories={subcategories}
                brands={this.props.brands}
                vendors={this.props.vendors}
                features={this.props.features}
                handleFilterChanged={this.handleFilterChanged}
                handleSelectOrdinationFilterChanged={this.handleSelectOrdinationFilterChanged}
                handleFilterRemove={this.handleFilterRemove}
                handleFilterClean={this.handleFilterClean}
                filterSelected={filterSelected}
                priceLimit={this.props.priceLimit}
                pageType='search'
                isLoading={isLoading}
                ordination={this.state.ordination}
                className={`${'d-none d-md-block'}`}
                onlyCash={this.props.onlyCash}
              />
              <div
                className={`container-card col-12 col-md-8 col-lg-9 pb-5 px-half px-md-1 ${
                  !this.state.condition
                    ? 'd-block d-md-block'
                    : 'd-none d-md-block'
                }`}
              >

                <MainComponent
                  titleShowcase={title}
                  categoryName={categoryName}
                  services={services}
                  products={products}
                  hasMoreItems={hasMoreItems}
                  isSearch={isSearch}
                  loadItems={this.loadItems}
                  activeTagging={this.activeTagging}
                  activePagination={this.activePagination}
                  notFound={notFound}
                  taggingSend={this.state.taggingSend}
                />
              </div>
            </div>
          </div>
        </div>

      </Fragment>
    )
  }
}

const mapStateToProps = ({ searchResult, router, onlyCash }) => ({
  ...SearchFiltered(searchResult, router),
  onlyCash
})

const mapDispatchToProps = dispatch => ({
  fetchResultSearch: (
    term,
    identifier,
    type,
    brands,
    categories,
    subcategories,
    vendors,
    vendortype,
    features,
    minprice,
    maxprice,
    sort,
    pageIndex
  ) =>
    dispatch(
      fetchResultSearch(null)(
        term,
        identifier,
        type,
        brands,
        categories,
        subcategories,
        vendors,
        vendortype,
        features,
        minprice,
        maxprice,
        sort,
        pageIndex
      )
    ),
  clearSearch: () => dispatch(clearSearch()),
  resetState: () => dispatch(resetState()),
  setFilterChanged: (filterName, filterSelected) =>
    dispatch(setFilterChanged(filterName, filterSelected)),
  setMeta: (title, description, keywords) =>
    dispatch(setMetadata(title, description, keywords))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchPage)



// WEBPACK FOOTER //
// ./src/Catalog/Search/Search/SearchPage.js